import Page from "webPage/Page";
import StyleGallery from "StyleGallery";
import MaterialGallery from "MaterialGallery";
import {handleTestimonials} from "util/handleTestimonials";
import VideoModal from "modals/VideoModal";

Page.register(['page-template-product-page', 'single-products', 'page-template-awnings', 'page-template-outdoor-blinds'], () => {
    let $body = $("body");

    $body.on('click', '.js-open-feature', function () {
        const $point = $(this).closest('.js-feature-point');
        updateFocusOffset($point);

        $('body').addClass('product-features-active');
        $(".js-feature-point").removeClass("feature-point--active feature-point--tablet-active");
        $point.addClass("feature-point--active");

        return false;
    }).on('click', '.js-close-feature', function () {
        $('body').removeClass('product-features-active');
        $(".feature-point").removeClass("feature-point--active feature-point--tablet-active");

        return false;
    }).on('click', '.js-feature-text', function (e) {
        e.stopPropagation();

    }).on("click", ".js-accordion-btn", function () {
        if ($(this).closest(".accordion").hasClass("accordion--active")) {
            $(this).closest(".accordion").toggleClass("accordion--active");
            $(this).closest(".accordion").find(".accordion__body").slideToggle();
        } else {
            $(".accordion--active").find(".accordion__body").slideUp();
            $(".accordion").removeClass("accordion--active");
            $(this).closest(".accordion").addClass("accordion--active");
            $(this).closest(".accordion").find(".accordion__body").slideToggle();
        }

    });

    if ($('.js-video-modal').length > 0) {
        $('body').on('click', '.js-video-modal', function () {
            let $pageVideoElement = $(this).find('video');
            let type = $(this).attr('data-type');
            console.log(type);
            let videoSrc = null;
            if ($pageVideoElement.length > 0 && type !== 'youtube') {
                $pageVideoElement[0].pause();
                videoSrc = $(this).find('source').attr('src');
            } else {
                videoSrc = $(this).attr('data-id');
            }

            let videoModal = new VideoModal(videoSrc, $pageVideoElement);
            videoModal.show();
        });
    }

    new MaterialGallery($('.js-material-section'));
    new StyleGallery($('.js-gallery'));
    new StyleGallery($('.js-installation-gallery'));

    handleTestimonials();

    $(window).on("resize", () => {
        // Update the calculated offset of any active feature points
        const $activePoint = $(".js-feature-point.feature-point--active");

        if ($activePoint.length > 0) {
            $activePoint.each((_, el) => updateFocusOffset($(el)));
        }
    });
});


function updateFocusOffset($point) {
    const $featurePointImgWrap = $point.find('.js-feature-point-img-wrap');

    const $image = $point.find('.js-feature-point-image');

    const imageWidth = $image.outerWidth();
    const imageHeight = $image.outerHeight();

    const wrapWidth = $featurePointImgWrap.outerWidth();
    const wrapHeight = $featurePointImgWrap.outerHeight();

    const posLeft = parseFloat($image.attr('data-pos-left'));
    const posTop = parseFloat($image.attr('data-pos-top'));

    const translateX = (wrapWidth / 2) - (imageWidth * (posLeft / 100));
    const translateY = (wrapHeight / 2) - (imageHeight * (posTop / 100));

    $image.css('transform', 'translate(' + Math.min(0, translateX) + 'px, ' + Math.min(0, translateY) + 'px )');
}
